import Vue from 'vue';
import Vuex from 'vuex';

import config from './config';
import models from './models';
import indicators from './indicators';
import util from './util';
import user from './user';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    config,
    models,
    indicators,
    util,
    user,
  },
});
